function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { useEffect, useState } from 'react';
import * as stylex from '@stylexjs/stylex';
import { __get, __put, isHttpWithData } from "nood-comp/src/net/xhr";
import LoadableListContainer from "nood-comp/src/comp/ui/containers/LoadableListContainer";
import CheckboxCollection from "nood-comp/src/comp/checkbox/CheckboxCollectionContext";
import Checkbox from "nood-comp/src/comp/checkbox/Checkbox";
import Div from "nood-comp/src/comp/ui/containers/Div";
import Form from "nood-comp/src/comp/form/Form";
import { useURLParam } from "nood-comp/src/hooks/useURLParam";
export default function OrgUserRolesEditor(props) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    roles = _useState2[0],
    setRoles = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    currentUserRoles = _useState4[0],
    setCurrentUserRoles = _useState4[1];
  var _useState5 = useState(undefined),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedRolesForm = _useState6[0],
    setSelectedRolesForm = _useState6[1];
  var orgUserID = useURLParam('id');
  useEffect(function () {
    if (selectedRolesForm !== void 0) {
      // __put(`/orguser/${orgUserID}?set=roles`, {
      //   body: JSON.stringify({
      //     roles: selectedRolesForm?.roles
      //   })
      // })
    }
  }, [selectedRolesForm]);
  useEffect(function () {
    if (orgUserID) {
      // get all the roles
      __get("/userroles", {}, function (res) {
        if (isHttpWithData(res)) {
          var _res$data;
          setRoles((_res$data = res.data) !== null && _res$data !== void 0 ? _res$data : []);
        }
      });
      __get("/userrolesmap?entity=ORG_MGR&entity_id=".concat(orgUserID), {}, function (res) {
        if (isHttpWithData(res)) {
          var currentRoles = res.data.map(function (userRoleMap) {
            return userRoleMap.user_role_id;
          });
          setSelectedRolesForm({
            roles: currentRoles
          });
        }
      });
    }
  }, [orgUserID]);
  var _putRole = function _putRole(roleID, isChecked) {
    __put("/set-role", {
      body: JSON.stringify({
        role_id: roleID,
        is_checked: isChecked,
        entity: 'ORG_MGR',
        entity_id: orgUserID
      })
    });
  };
  return /*#__PURE__*/React.createElement(Div, {
    pad: 20
  }, /*#__PURE__*/React.createElement(LoadableListContainer, {
    list: roles
  }, (roles === null || roles === void 0 ? void 0 : roles.length) > 0 && /*#__PURE__*/React.createElement(Form, {
    obj: selectedRolesForm,
    __setter: setSelectedRolesForm
  }, /*#__PURE__*/React.createElement(CheckboxCollection, {
    name: 'roles',
    gap: 15,
    label: 'Roles'
  }, roles.map(function (role, idx) {
    return /*#__PURE__*/React.createElement(Checkbox, {
      key: "user-role-cb-".concat(idx),
      label: role.name,
      value: role.id,
      caption: role.description,
      __click: function __click(isChecked) {
        _putRole(role.id, isChecked);
      }
    });
  })))));
}
OrgUserRolesEditor.propTypes = {
  // proptypes
};
OrgUserRolesEditor.defaultProps = {
  // default propTypes
};